import { Middleware } from 'redux';
import RootState from 'store/state';
import AnyAction from 'store/anyActions';
import AppTypes from 'store/app/app.types';
import UserTypes from 'store/user/user.types';

import Logger from '../../logger';

let actionLog: string[] = [];

const LoggerMiddleware: Middleware<{}, RootState> = store => next => async (action: AnyAction) => {
    actionLog = [action.type, ...actionLog.slice(0, 9)];
    switch (action.type) {
        case UserTypes.USER_LOADED:
            Logger.addUser({
                id: action.payload.agentID,
                username: `${store.getState().app.ID}:${action.payload.username}`,
            });

            return next(action);

        case AppTypes.INIT_APP_SUCCESS:
            Logger.addCompanyId(action.payload.ID);
            return next(action);

        case AppTypes.INIT_APP_FAIL:
            Logger.error(action.type, store.getState());
            return next(action);

        case UserTypes.USER_AUTH_ERROR:
            Logger.warning(action.type, { actionLog });
            return next(action);

        default:
            return next(action);
    }
};

export default LoggerMiddleware;
